import React, { useEffect, useState } from "react";
import { wait } from "../../../../utils/utils";
import { useHasDrafts } from "components/Signup/store/selectors/animals";
import { StepProps } from "../types";
import { useError } from "components/Signup/store/selectors/metadata";
import Router from "next/router";
import { LoadingScreen } from "components/Signup/components/LoadingScreen";

const STEP_TIMEOUT = 1.0;

const SettingUp = ({ next, previous }: StepProps) => {
  const [promiseIndex, setPromiseIndex] = useState<number>(-1);

  const hasQuotePreviews = useHasDrafts();
  const error = useError();

  useEffect(() => {
    if (error) {
      if (previous) {
        previous(true);
      } else {
        Router.back();
      }
    }
  }, [error, previous]);

  useEffect(() => {
    (async () => {
      setPromiseIndex(0);
      await wait(STEP_TIMEOUT);
      setPromiseIndex(1);
      await wait(STEP_TIMEOUT);
      setPromiseIndex(2);
      await wait(STEP_TIMEOUT);
      setPromiseIndex(3);
    })();
  }, []);

  useEffect(() => {
    if (hasQuotePreviews && promiseIndex === 3) {
      next(true);
    }
  }, [hasQuotePreviews, promiseIndex, next]);

  return <LoadingScreen />;
};

export default SettingUp;
